module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zbsz-box"
  }, [_c('yinliang', {
    on: {
      "setVol": _vm.setVolume
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-item",
    on: {
      "click": _vm.handleShowGly
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/zbsz_guanliyuan_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.guanliyuan')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-item",
    on: {
      "click": _vm.handleShowKjdy
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/zbsz_kuaijiefayan_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.kuaijieduanyu')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-item",
    on: {
      "click": _vm.handleShowGg
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/image/zbsz_gonggao_28@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.gonggao')))])]), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-xian"
  }), _vm._v(" "), _c('div', {
    staticClass: "zbsz-box-item",
    on: {
      "click": _vm.handleShowSvga
    }
  }, [(_vm.isSvga) ? _c('img', {
    attrs: {
      "src": require("../../assets/image/zbsz_kqtexiao_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSvga) ? _c('img', {
    attrs: {
      "src": require("../../assets/image/zbsz_guanbitexiao_28@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.liwutexiao')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32bc1781"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/zhuboshezhi/zhuboshezhi.vue
// module id = 813
// module chunks = 1